(function () {
  const SECTION_SELECTOR = '.electrolytes-scoop-chew';
  const TRACK_SELECTOR = '.electrolytes-scoop-chew__cards';
  const SLIDE_SELECTOR = '.electrolytes-scoop-chew__card';
  const PREV_SELECTOR = '.electrolytes-scoop-chew__nav-btn--prev';
  const NEXT_SELECTOR = '.electrolytes-scoop-chew__nav-btn--next';
  const PAGINATION_SELECTOR = '.electrolytes-scoop-chew__pagination';
  const MOBILE_BREAKPOINT = '(max-width: 650px)';

  let dragState = null;

  function getSliderParts(section) {
    if (!section) return null;

    const track = section.querySelector(TRACK_SELECTOR);
    const slides = Array.from(section.querySelectorAll(SLIDE_SELECTOR));
    if (!track || !slides.length) return null;

    return {
      track: track,
      slides: slides,
      prevButton: section.querySelector(PREV_SELECTOR),
      nextButton: section.querySelector(NEXT_SELECTOR),
      pagination: section.querySelector(PAGINATION_SELECTOR)
    };
  }

  function getClosestIndex(parts) {
    const trackLeft = parts.track.getBoundingClientRect().left;
    let closestIndex = 0;
    let closestDistance = Infinity;

    parts.slides.forEach(function (slide, index) {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function updateControls(section) {
    const parts = getSliderParts(section);
    if (!parts) return;

    const currentIndex = getClosestIndex(parts);
    if (parts.pagination) {
      parts.pagination.textContent = (currentIndex + 1) + ' - ' + parts.slides.length;
    }
    if (parts.prevButton) parts.prevButton.disabled = currentIndex === 0;
    if (parts.nextButton) parts.nextButton.disabled = currentIndex === parts.slides.length - 1;
    section.dataset.scoopChewSliderInitialized = 'true';
  }

  function goTo(section, index) {
    const parts = getSliderParts(section);
    if (!parts) return;

    const targetIndex = Math.max(0, Math.min(index, parts.slides.length - 1));
    const trackRect = parts.track.getBoundingClientRect();
    const slideRect = parts.slides[targetIndex].getBoundingClientRect();
    const targetLeft = parts.track.scrollLeft + slideRect.left - trackRect.left;

    parts.track.scrollTo({ left: targetLeft, behavior: 'smooth' });

    if (parts.pagination) {
      parts.pagination.textContent = (targetIndex + 1) + ' - ' + parts.slides.length;
    }
    if (parts.prevButton) parts.prevButton.disabled = targetIndex === 0;
    if (parts.nextButton) parts.nextButton.disabled = targetIndex === parts.slides.length - 1;
  }

  function handleClick(event) {
    const button = event.target.closest(PREV_SELECTOR + ', ' + NEXT_SELECTOR);
    if (!button) return;

    const section = button.closest(SECTION_SELECTOR);
    const parts = getSliderParts(section);
    if (!parts) return;

    const currentIndex = getClosestIndex(parts);
    goTo(section, button.matches(NEXT_SELECTOR) ? currentIndex + 1 : currentIndex - 1);
  }

  function handleScroll(event) {
    const track = event.target;
    if (!(track instanceof Element) || !track.matches(TRACK_SELECTOR)) return;
    if (track.dataset.scoopChewScrollQueued === 'true') return;

    track.dataset.scoopChewScrollQueued = 'true';
    window.requestAnimationFrame(function () {
      delete track.dataset.scoopChewScrollQueued;
      updateControls(track.closest(SECTION_SELECTOR));
    });
  }

  function finishDrag(event, shouldSnap) {
    if (!dragState || (event && event.pointerId !== dragState.pointerId)) return;

    const state = dragState;
    dragState = null;
    state.track.classList.remove('is-dragging');

    if (state.track.hasPointerCapture && state.track.hasPointerCapture(state.pointerId)) {
      state.track.releasePointerCapture(state.pointerId);
    }

    if (shouldSnap && state.axis === 'horizontal') {
      const section = state.track.closest(SECTION_SELECTOR);
      const parts = getSliderParts(section);
      if (parts) goTo(section, getClosestIndex(parts));
    }
  }

  function handlePointerDown(event) {
    const target = event.target;
    if (!(target instanceof Element) || !window.matchMedia(MOBILE_BREAKPOINT).matches) return;

    const track = target.closest(TRACK_SELECTOR);
    if (!track || (event.pointerType === 'mouse' && event.button !== 0)) return;

    dragState = {
      track: track,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startScrollLeft: track.scrollLeft,
      axis: null
    };

    track.classList.add('is-dragging');
    if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
  }

  function handlePointerMove(event) {
    if (!dragState || event.pointerId !== dragState.pointerId) return;

    const deltaX = event.clientX - dragState.startX;
    const deltaY = event.clientY - dragState.startY;

    if (!dragState.axis && Math.max(Math.abs(deltaX), Math.abs(deltaY)) >= 5) {
      dragState.axis = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
    }

    if (dragState.axis === 'vertical') {
      finishDrag(event, false);
      return;
    }

    if (dragState.axis === 'horizontal') {
      event.preventDefault();
      dragState.track.scrollLeft = dragState.startScrollLeft - deltaX;
    }
  }

  function handlePointerUp(event) {
    finishDrag(event, true);
  }

  function handlePointerCancel(event) {
    finishDrag(event, false);
  }

  function updateAll(root) {
    if (root instanceof Element && root.matches(SECTION_SELECTOR)) {
      updateControls(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(SECTION_SELECTOR).forEach(updateControls);
    }
  }

  function start() {
    updateAll(document);
    document.addEventListener('click', handleClick);
    document.addEventListener('scroll', handleScroll, true);
    document.addEventListener('pointerdown', handlePointerDown);
    document.addEventListener('pointermove', handlePointerMove, { passive: false });
    document.addEventListener('pointerup', handlePointerUp);
    document.addEventListener('pointercancel', handlePointerCancel);

    const observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) updateAll(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    updateAll(event.target);
  });
})();
